<template>
  <el-config-provider :locale="locale">
    <router-view></router-view>
  </el-config-provider>
</template>
<script>
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
export default {
  name: "App",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  data() {
    return {
      locale: zhCn,
    };
  },
  created() {
    // 页面刷新后vuex中的数据会重置,解决方法:
    // 刷新前: 将数据存入sessionStorage中
    window.addEventListener("beforeunload", () => {
      console.log(this.$store.state);
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    // 刷新后: vuex再从sessionStorage中读取
    const store = sessionStorage.getItem("store");
    if (store) {
      this.$store.replaceState(
        Object.assign({}, this.$store.state, JSON.parse(store))
      );
    }
  },
  methods: {},
};
</script>



<style>
@import url("assets/css/base.css");
</style>